/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const ACTIONS_DISABLED_STATE_TOGGLE_EVENT = 'dell.sirius.action-handler.actions-disabled.state-changed';